import React from 'react';

import { NoActiveFiresIcon } from './noActiveFiresIcon';
import styled from 'styled-components';

interface NoActiveFiresType {
    backgroundColor: string;
    fontColor: string;
}

export const NoActiveFires = ({ 
    backgroundColor = '#FFFFFF', 
    fontColor = '#555555'
}: NoActiveFiresType) => {
    return (
        <Container backgroundColor={backgroundColor}>
            <NoActiveFiresIcon color={fontColor} />
            <TextSpan fontColor={fontColor}>
                NO ACTIVE FIRES
            </TextSpan>
        </Container>
    );
}

interface ContainerType {backgroundColor: string}
const Container = styled.div<ContainerType>`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    background-color: ${({ backgroundColor }) => backgroundColor};
`;

interface TextSpanType {fontColor: string}
const TextSpan = styled.span<TextSpanType>`
    font-size: 15px;
    font-family: 'Source Sans Pro', sans-serif;
    padding-top: 24px;
    color: ${({ fontColor }) => fontColor};
`;
